import { render } from "./CallBar.vue?vue&type=template&id=ab95fa20&scoped=true"
import script from "./CallBar.vue?vue&type=script&lang=js"
export * from "./CallBar.vue?vue&type=script&lang=js"

import "./CallBar.vue?vue&type=style&index=0&id=ab95fa20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab95fa20"]])

export default __exports__